import React from 'react';
import { NeonLoadingIndicator } from '@ps-refarch-ux/neon';
import './modal-loader.scss';
export default function ModalLoader() {
    return (React.createElement("div", { className: 'mfe-beh-smart-groups-modal-container' },
        React.createElement(NeonLoadingIndicator, { dataSize: "large" })));
}
